import { formatNumber } from '../../utils/partidasFormatters';

const MetricCard = ({ label, value, tone }) => (
  <div className={`partidas-metric-card ${tone}`}>
    <span>{label}</span>
    <strong>{formatNumber(value, 3)}</strong>
  </div>
);

export default function PartidasMetricas({ summary }) {
  const recordCards = [
    ['Total registros', summary.total_registros, 'is-red'],
    ['Vencen en 30 días', summary.vencen_30_registros, 'is-red'],
    ['Vencen en 60 días', summary.vencen_60_registros, 'is-red'],
    ['Vencen en 90 días', summary.vencen_90_registros, 'is-red'],
  ];
  const unitCards = [
    ['Total unidades', summary.total_unidades, 'is-blue'],
    ['Unidades en 30 días', summary.vencen_30_unidades, 'is-blue'],
    ['Unidades en 60 días', summary.vencen_60_unidades, 'is-blue'],
    ['Unidades en 90 días', summary.vencen_90_unidades, 'is-blue'],
  ];

  return (
    <div className='partidas-metrics-section'>
      <div>
        <div className='partidas-metric-heading'>
          <span>Registros</span>
          <h2>Partidas próximas a vencer</h2>
        </div>
        <div className='partidas-metrics-grid'>
          {recordCards.map(([label, value, tone]) => (
            <MetricCard key={label} label={label} value={value} tone={tone} />
          ))}
        </div>
      </div>

      <div>
        <div className='partidas-metric-heading'>
          <span>Existencias</span>
          <h2>Unidades próximas a vencer</h2>
        </div>
        <div className='partidas-metrics-grid'>
          {unitCards.map(([label, value, tone]) => (
            <MetricCard key={label} label={label} value={value} tone={tone} />
          ))}
        </div>
      </div>
    </div>
  );
}
